import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import get from "lodash/get";
import isString from "lodash/isString";
import { log } from "@jutro/logger";
import { REF_PROPERTY, REF_PROPERTY_SHORTCUT, refTypeMap } from "../common/refs";
export function resolveContentReference(item, rootMetadata) {
  return isString(item) && _startsWithInstanceProperty(item).call(item, REF_PROPERTY_SHORTCUT) ? extendMetadata(void 0, item.substr(REF_PROPERTY_SHORTCUT.length), rootMetadata) : item[REF_PROPERTY] ? extendMetadata(item, item[REF_PROPERTY], rootMetadata) : item;
}
export function extendMetadata(targetItem, refKey, rootMetadata) {
  if (!refKey) return targetItem;
  var parts = refKey.split("/"),
    baseItem = get(rootMetadata, parts);
  if (!baseItem) return log.warning('unable to resolve @ref: "'.concat(refKey, '"')), targetItem;
  var extendedItem = baseItem;
  return targetItem && (delete (extendedItem = _objectSpread(_objectSpread({}, baseItem), targetItem))[REF_PROPERTY], baseItem.componentProps && targetItem.componentProps && (extendedItem.componentProps = _objectSpread(_objectSpread({}, baseItem.componentProps), targetItem.componentProps))), function (extendedItem, parts, refKey) {
    if (!extendedItem.id || !extendedItem.type) {
      var _parts = _slicedToArray(parts, 2),
        idFromRefKey = _parts[0],
        typeFromRefKey = _parts[1];
      extendedItem.id || (idFromRefKey ? extendedItem.id = idFromRefKey : log.warning("unable to resolve 'id' from: \"".concat(refKey, '"'))), extendedItem.type || (typeFromRefKey ? extendedItem.type = refTypeMap[typeFromRefKey] : log.warning("unable to resolve 'type' from: \"".concat(refKey, '"')));
    }
  }(extendedItem, parts.reverse(), refKey), extendedItem;
}